import { useTranslation } from "react-i18next";
import { Avatar, Box, Link, Typography } from "@mui/material";

import { UserVerifiedIcon } from "../../assets/icons/go-service-icons";

import { styles } from "./styles";

interface ProviderDetailsProps {
  fullName: string;
  firstTwoChr: string;
  media?: string;
  club?: string;
  role?: string;
  isVerified?: boolean;
  profileLink?: string;
}

export const ProviderDetails = ({
  fullName,
  firstTwoChr,
  media,
  club,
  role,
  isVerified,
  profileLink,
}: ProviderDetailsProps) => {
  const { t } = useTranslation("goService", { keyPrefix: "servicePage" });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <Typography sx={styles.providerDetailsTitle}>{t("providerDetails")}</Typography>
      <Box sx={styles.userInfoContainer}>
        <Box sx={styles.avatarContainer}>
          <Avatar src={media} sx={styles.avatar}>
            {firstTwoChr}
          </Avatar>
          {isVerified && <UserVerifiedIcon sx={styles.verifiedIcon} />}
        </Box>
        <Box sx={styles.userInfo}>
          <Typography sx={styles.userName} component={profileLink ? Link : "span"} href={profileLink}>
            {fullName}
          </Typography>
          <Typography sx={styles.userRole}>
            {role} {club && `• ${club}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
